import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export enum FactoryType {
    OWNED = "OWNED",
    PARTNER = "PARTNER",
}

export interface IFactoryResource extends ITimestampable, IHydraResource {
    "@type": EntityTypes.FACTORY;
    title: string;
    type: string;
}

export const isFactoryResource = (resource: IHydraResource): resource is IFactoryResource => {
    return resource["@type"] === EntityTypes.FACTORY;
};
